<div class="relative">
  <button
    type="button"
    class="flex w-full items-center justify-between gap-3 rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900 shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900/20"
    [attr.id]="triggerId()"
    [attr.aria-label]="ariaLabel() || 'Select date'"
    [attr.aria-controls]="panelId()"
    [attr.aria-expanded]="open()"
    [attr.aria-describedby]="describedBy()"
    [attr.aria-required]="required()"
    [attr.aria-disabled]="isDisabled()"
    [disabled]="isDisabled()"
    role="combobox"
    aria-haspopup="dialog"
    (click)="togglePanel(); $event.preventDefault()"
    (keydown)="handleTriggerKeydown($event)">
    <span class="truncate" [class.text-slate-400]="!displayValue()">
      {{ displayValue() || placeholder() }}
    </span>
    <span class="material-symbols-outlined text-base text-slate-500" aria-hidden="true">calendar_today</span>
  </button>

  @if (open()) {
    <div
      class="absolute left-0 z-20 mt-2 w-72 rounded-xl border border-slate-200 bg-white p-4 shadow-xl"
      role="dialog"
      [attr.id]="panelId()"
      aria-modal="false">
      <div class="flex items-center justify-between pb-3">
        <button
          type="button"
          class="rounded-full p-2 text-slate-500 transition hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900/20"
          (click)="focusPreviousMonth()"
          aria-label="Previous month">
          <span class="material-symbols-outlined text-base" aria-hidden="true">chevron_left</span>
        </button>
        <span class="text-sm font-semibold text-slate-900">{{ monthLabel() }}</span>
        <button
          type="button"
          class="rounded-full p-2 text-slate-500 transition hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900/20"
          (click)="focusNextMonth()"
          aria-label="Next month">
          <span class="material-symbols-outlined text-base" aria-hidden="true">chevron_right</span>
        </button>
      </div>

      <div class="grid grid-cols-7 gap-1 text-center text-[11px] font-semibold text-slate-500">
        @for (label of weekdayLabels; track label) {
          <span class="uppercase">{{ label }}</span>
        }
      </div>

      <div class="mt-2 grid grid-cols-7 gap-1">
        @for (week of weeks(); track $index) {
          @for (day of week; track day.date.toISOString()) {
            <button
              type="button"
              class="flex h-9 w-9 items-center justify-center rounded-lg text-xs font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900/20"
              [class.text-slate-400]="!day.inMonth"
              [class.text-slate-300]="day.isDisabled"
              [class.cursor-not-allowed]="day.isDisabled"
              [class.bg-slate-900]="day.isSelected"
              [class.text-white]="day.isSelected"
              [class.ring-1]="day.isToday && !day.isSelected"
              [class.ring-slate-900/30]="day.isToday && !day.isSelected"
              [class.hover:bg-slate-100]="!day.isSelected && !day.isDisabled"
              [class.hover:text-slate-900]="!day.isSelected && !day.isDisabled"
              [disabled]="day.isDisabled"
              (click)="selectDay(day, $event)">
              {{ day.date.getDate() }}
            </button>
          }
        }
      </div>

      <div class="mt-3 flex items-center justify-between text-xs">
        <button
          type="button"
          class="text-slate-500 transition hover:text-slate-900"
          [disabled]="!value()"
          [class.opacity-50]="!value()"
          [class.cursor-not-allowed]="!value()"
          (click)="clearDate($event)">
          Clear
        </button>
        <button
          type="button"
          class="rounded-md border border-slate-200 px-2.5 py-1 text-slate-600 transition hover:bg-slate-100"
          (click)="closePanel(); $event.preventDefault()">
          Close
        </button>
      </div>
    </div>
  }
</div>
